import { signInResetPasswordFormStyles } from "@insite/content-library/Widgets/SignIn/SignInResetPasswordForm";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { isThemeActive, THEME_IDS } from "@tSurya/theme/themeHelper";
import { css } from "styled-components";

signInResetPasswordFormStyles.descriptionText = {
    css: css`
        font-family: ${TYPOGRAPHY.fontFamily.title};
        font-style: normal;
        font-weight: ${TYPOGRAPHY.weight.base} !important;
        font-size: ${TYPOGRAPHY.size.smaller};
        line-height: ${isThemeActive(THEME_IDS.MGBW) ? "21px" : TYPOGRAPHY.lineHeight.base};
        color: ${getColor("text.accent")} !important;
    `,
}

signInResetPasswordFormStyles.userNameTextField = {
    css: css`
        font-family: ${TYPOGRAPHY.fontFamily.title} !important;
        font-style: normal;
        font-weight: ${TYPOGRAPHY.weight.base} !important;
        font-size: ${isThemeActive(THEME_IDS.MGBW) ? TYPOGRAPHY.size.smaller : TYPOGRAPHY.size.small} !important;
        line-height: ${TYPOGRAPHY.lineHeight.xbase};
        color: ${getColor("text.accent")} !important;
    `,
}

signInResetPasswordFormStyles.userNameGridItem = {
    css: css`
        flex-basis: 100% !important;
        max-width: 100% !important;
        > div[class^="FormFieldStyle"] > label {
            font-family: ${TYPOGRAPHY.fontFamily.title} !important;
            font-style: normal;
            font-weight: ${isThemeActive(THEME_IDS.MGBW) ? "600" : TYPOGRAPHY.weight.bold} !important;
            font-size: ${TYPOGRAPHY.size.smaller} !important;
            line-height: ${TYPOGRAPHY.lineHeight.base};
            color: ${getColor("text.main")} !important;
        }
    `,
}

signInResetPasswordFormStyles.buttonsGridItem = {
    css: css`
        display: flex;
        justify-content: space-between;
        flex-basis: 100%;
        max-width: 100%;
    `,
}

signInResetPasswordFormStyles.cancelButton = {
    css: css`
        ${!isThemeActive(THEME_IDS.MGBW) && css`
            border-radius: 0px;
            min-height: 44px !important;
            background: ${getColor("primary")};
            > span {
                font-family: ${TYPOGRAPHY.button.fontFamily} !important;
                font-style: normal;
                font-weight: ${TYPOGRAPHY.button.weight} !important;
                font-size: ${TYPOGRAPHY.button.size} !important;
                line-height: ${TYPOGRAPHY.button.lineHeight};
                color: ${getColor("primary.contrast")} !important;
            }
        `}
    `,
}

signInResetPasswordFormStyles.sendButton = {
    css: css`
        ${!isThemeActive(THEME_IDS.MGBW) && css`
            border-radius: 0px;
            min-height: 44px !important;
            background: ${getColor("primary")};
            > span {
                font-family: ${TYPOGRAPHY.button.fontFamily} !important;
                font-style: normal;
                font-weight: ${TYPOGRAPHY.button.weight} !important;
                font-size: ${TYPOGRAPHY.button.size} !important;
                line-height: ${TYPOGRAPHY.button.lineHeight};
                color: ${getColor("primary.contrast")} !important;
            }
        `}
    `,
}